import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
import FilePreview from "../FilePreview";
import "./DisputesView.css";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const DisputesView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [openComplaints, setOpenComplaints] = useState([]);
  const [openReceivedComplaints, setOpenReceivedComplaints] = useState([]);
  const [receivedComplaint, setReceivedComplaints] = useState([]);
  const [closedComplaints, setClosedComplaints] = useState([]);
  const [closedReceivedComplaints, setClosedReceivedComplaints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openIssue, setOpenIssue] = useState(false);
  const [alljobId, setAllJobId] = useState([]);
  const [attachement, setAttachement] = useState("");
  const [attachementFileName, setattachementFileName] = useState("");
  const [fileValidtion, setFilevalidation] = useState("");
  const [jobIdValidation, setjobIdValidation] = useState('');
  const [issueValidation, setIssueValidation] = useState('');
  const [detailsValidation, setDetailsValidation] = useState('');
  const [jobId, setJobId] = useState('');
  const [issue, setIssue] = useState('');
  const [details, setDetails] = useState('');
  const [title, setTitle] = useState('');
  const [issueloader, setIssueLoader] = useState(false);
  const [openErrormsg, setOpenErrormsg] = useState("");
  const [closedErrormsg, setClosedErrormsg] = useState("");
  const [receivedOpenErrorMsg, setReceivedOpenErrorMsg] = useState("");
  const [receivedClosedErrorMsg, setReceivedClosedErrorMsg] = useState("");
  const [activeTab, setActiveTab] = useState('raised');
  const [raisedFilter, setRaisedFilter] = useState('all');
  const [receivedFilter, setReceivedFilter] = useState('all');
  const [filePreviewModal, setFilePreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState('');  
  



  useEffect(() => {
  
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    getOpenComplaints();
    getAllJobId();
    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };
  const onFilesChange = (files) => {
    let file = files[0];

    setAttachement({
      name: file.name,
      uri: file.preview.url,
      type: file.type,
    });
  };

  const handleFileSelect = (event) => {
    let ufile = event.target.files[0];
    setAttachement(ufile);
    setattachementFileName(ufile.name);
    
  }

  const handleFileClick = (fileUrl) => {
    if (fileUrl) {
      setPreviewFileUrl(fileUrl);
      setFilePreviewModal(true);
    }
  }

  const onFilesError = (error, file) => {
    toast.success(error.message, {
      position: "top-right",
      type: "error",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
    });
  };
  const redirect = () => {
    history.push("/ExperienceUpdate");
  };



  const filterComplaints = (complaints, filter) => {
  if (filter === 'all') return complaints;
  if (filter === 'open') {
    return complaints.filter(item => item.status === 'Open' || item.status === 'open');
  }
  if (filter === 'closed') {
    return complaints.filter(item => item.status === 'Closed' || item.status === 'closed');
  }
  return complaints;
};


// Apply filters
const filteredOpenComplaints = raisedFilter === 'all' 
  ? openComplaints 
  : openComplaints.filter(item => {
      const status = item.status?.toLowerCase();
      return status === raisedFilter;
    });

const filteredClosedComplaints = raisedFilter === 'all'
  ? closedComplaints
  : closedComplaints.filter(item => {
      const status = item.status?.toLowerCase();
      return status === raisedFilter;
    });

  const filteredReceivedOpenComplaints = receivedFilter === 'all' 
  ? openReceivedComplaints 
  : openReceivedComplaints.filter(item => {
      const status = item.status?.toLowerCase();
      return status === receivedFilter;
    });

  const filteredReceivedClosedComplaints = receivedFilter === 'all'
  ? closedReceivedComplaints
  : closedReceivedComplaints.filter(item => {
      const status = item.status?.toLowerCase();
      return status === receivedFilter;
    });


  
  const submitIssue = () => {
   

    if (jobId == '') {
      toast.success('Please select a JobId', {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    if (issue == '') {
      toast.success('Please select an Issue', {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    if (details == '') {
      toast.success('Please enter valid details', {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    if (title == '') {
      toast.success('Please enter a title', {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    setIssueLoader(true);
    const FormData = require("form-data");

    const form = new FormData();
    form.append('job_id',jobId);
    form.append('complaint',issue);
    form.append('details',details);
    form.append('title',title);

    if (attachement != '') {
    form.append('attach_file',attachement);
    }

    commonService
      .CommonService("raise_complaint", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          setOpenIssue(false);
          setJobId('');
          setIssue('');
          setDetails('');
          setTitle('');
          setAttachement("");
          setattachementFileName("");
          // Refresh the complaints list to show the newly raised dispute
          getOpenComplaints();
          // Ensure we're on the "I Raised" tab to see the new dispute
          setActiveTab('raised');
          // Remove navigation since we're refreshing the list directly
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setIssueLoader(false);

      });
    

  }


  const getAllJobId = () => {

    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("get_all_job_id", form)
      .then(async (res) => {
        if (res.status == 200) {
          setAllJobId(res.data);
        } else {
         
        }
      })
      .catch((err) => {
      
      })
      .finally(() => {
      });
  };
  const getOpenComplaints = () => {
    setLoading(true);

    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("complaints_raised", form)
      .then(async (res) => {
        if (res.status == 200) {
          setOpenComplaints(res.data);
        } else {
           setOpenErrormsg(res.message)
        }
      })
      .catch((err) => {
        setOpenErrormsg("Something went wrong! please try again later!!")

      })
      .finally(() => {
       setLoading(false);
      });
  };

  const receivedComplaints = () => {
    setLoading(true);

    const FormData = require("form-data");
    const form = new FormData();

    commonService
      .CommonService("complaints_received", form)
      .then(async (res) => {
        if (res.status == 200) {
          setOpenReceivedComplaints(res.data);
        } else {
          setReceivedOpenErrorMsg(res.message);
        }
      })
      .catch((err) => {
        setReceivedOpenErrorMsg("Something went wrong! please try again later!!");
      })
      .finally(() => {
        setLoading(false);
      });
  };



  return (
  <section className="post contract">
    <LoadingOverlay>
      <div className="container">
        <div className="banner paddimg-bottom">
          <div className="row">
            <div className="col-md-4">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <div onClick={back}>
                      <a href="#">
                        <i className="bx bx-chevron-left" /> Back to all jobs
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 offset-md-4 disputes-raise-button-container">
              <a href="#!" className="btn disputes-raise-button" onClick={() => setOpenIssue(true)}>
               Raise an Issue 
              </a>
            </div>
          </div>
        </div>

        <div className="disputes-container">
          <div key={activeTab} className="disputes-animation-overlay"></div>
          <div className="disputes-content-wrapper">
            <h1 className="disputes-title">Disputes</h1>
            
            <div className="disputes-tab-container">
              <div 
                className={`disputes-tab ${activeTab === 'raised' ? 'disputes-active-tab' : ''}`}
                onClick={() => {
                  setActiveTab('raised');
                  getOpenComplaints();
                }}
              >
                I Raised
              </div>
              <div 
                className={`disputes-tab ${activeTab === 'received' ? 'disputes-active-tab' : ''}`}
                onClick={() => {
                  setActiveTab('received');
                  receivedComplaints();
                }}
              >
                I Received
              </div>
            </div>

            {activeTab === 'raised' && (
              <div>
                <div className="disputes-sub-tab-container">
                  <div 
                    className={`disputes-sub-tab ${raisedFilter === 'all' ? 'disputes-active-sub-tab' : ''}`}
                    onClick={() => setRaisedFilter('all')}
                  >
                    All
                  </div>
                  <div 
                    className={`disputes-sub-tab ${raisedFilter === 'open' ? 'disputes-active-sub-tab' : ''}`}
                    onClick={() => setRaisedFilter('open')}
                  >
                    Open
                  </div>
                  <div 
                    className={`disputes-sub-tab ${raisedFilter === 'closed' ? 'disputes-active-sub-tab' : ''}`}
                    onClick={() => setRaisedFilter('closed')}
                  >
                    Closed
                  </div>
                </div>

                <div className="disputes-content">
                  {filteredOpenComplaints.length === 0 ? (
                    <div className="disputes-empty-state">
                      {openErrormsg || 'No complaints found'}
                    </div>
                  ) : (
                    filteredOpenComplaints.map((item, index) => {
                      const statusClass = item.status && (item.status.toLowerCase() === 'open' || item.status.toLowerCase() === 'closed') 
                        ? (item.status.toLowerCase() === 'open' ? 'disputes-status-open' : 'disputes-status-closed')
                        : 'disputes-status-default';
                      const isClosed = item.status && item.status.toLowerCase() === 'closed';
                      const hasAdminComment = isClosed && item.admin_comments !== null && item.admin_comments !== undefined && item.admin_comments !== '';
                      const hasAttachment = item.attach_file !== null && item.attach_file !== undefined && item.attach_file !== '';
                      
                      return (
                        <div key={index} className="disputes-card">
                          <div className="disputes-card-header">
                            <div className="disputes-card-header-content">
                              {item.dispute_id && (
                                <p className="disputes-dispute-id">
                                  {item.dispute_id}
                                </p>
                              )}
                              <h3 className="disputes-card-title">
                                {item.title || 'Complaint'}
                              </h3>
                              {(item.job_id || item.jobId) && (
                                <p className="disputes-job-id-container">
                                  <span className="disputes-job-id-label"></span> <span className="disputes-job-id-value">{item.job_id || item.jobId}</span>
                                </p>
                              )}
                            </div>
                            <button className={`disputes-status-badge ${statusClass}`}>
                              {item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase() : item.status}
                            </button>
                          </div>
                          
                          {item.complaint && (
                            <p className="disputes-reason-container">
                              <span className="disputes-reason-label">Reason</span> <span className="disputes-reason-value">{item.complaint}</span>
                            </p>
                          )}
                          
                          {item.raised_against_user_name && (
                            <p className="disputes-raised-against-container">
                              <span className="disputes-raised-against-label">Raised Against</span> <span className="disputes-raised-against-value">{item.raised_against_user_name}</span>
                            </p>
                          )}
                          
                          {item.created_at && (
                            <p className="disputes-date-container">
                              Issue Raised on {moment(item.created_at).format('MMM DD, YYYY ')}
                            </p>
                          )}
                          
                          {hasAttachment && (
                            <div 
                              className="disputes-attachment-container"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleFileClick(item.attach_file);
                              }}
                              onMouseDown={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <div onClick={(e) => e.stopPropagation()}>
                                <FilePreview fileUrl={item.attach_file} />
                              </div>
                            </div>
                          )}
                          
                          {hasAdminComment && (
                            <div className="disputes-admin-comment-container">
                              <p className="disputes-admin-comment-title">
                                Admin Comment:
                              </p>
                              <p className="disputes-admin-comment-text">
                                {item.admin_comments}
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>


                 
              </div>
            )}

            {activeTab === 'received' && (
              <div>
                <div className="disputes-sub-tab-container">
                  <div 
                    className={`disputes-sub-tab ${receivedFilter === 'all' ? 'disputes-active-sub-tab' : ''}`}
                    onClick={() => setReceivedFilter('all')}
                  >
                    All
                  </div>
                  <div 
                    className={`disputes-sub-tab ${receivedFilter === 'open' ? 'disputes-active-sub-tab' : ''}`}
                    onClick={() => setReceivedFilter('open')}
                  >
                    Open
                  </div>
                  <div 
                    className={`disputes-sub-tab ${receivedFilter === 'closed' ? 'disputes-active-sub-tab' : ''}`}
                    onClick={() => setReceivedFilter('closed')}
                  >
                    Closed
                  </div>
                </div>

                 <div className="disputes-content-received">
                  {filteredReceivedOpenComplaints.length === 0 ? (
                    <div className="disputes-empty-state">
                      {receivedOpenErrorMsg || 'No complaints found'}
                    </div>
                  ) : (
                    filteredReceivedOpenComplaints.map((item, index) => {
                      const statusClass = item.status && (item.status.toLowerCase() === 'open' || item.status.toLowerCase() === 'closed') 
                        ? (item.status.toLowerCase() === 'open' ? 'disputes-status-open' : 'disputes-status-closed')
                        : 'disputes-status-default';
                      const isClosed = item.status && item.status.toLowerCase() === 'closed';
                      const hasAdminComment = isClosed && item.admin_comments !== null && item.admin_comments !== undefined && item.admin_comments !== '';
                      const hasAttachment = item.attach_file !== null && item.attach_file !== undefined && item.attach_file !== '';
                      
                      return (
                        <div key={index} className="disputes-card">
                          <div className="disputes-card-header">
                            <div className="disputes-card-header-content">
                              {item.dispute_id && (
                                <p className="disputes-dispute-id">
                                  Dispute #{item.dispute_id}
                                </p>
                              )}
                              <h3 className="disputes-card-title">
                                {item.title || 'Complaint'}
                              </h3>
                              {(item.job_id || item.jobId) && (
                                <p className="disputes-job-id-container">
                                  <span className="disputes-job-id-label">JobId</span> <span className="disputes-job-id-value">{item.job_id || item.jobId}</span>
                                </p>
                              )}
                            </div>
                            <button className={`disputes-status-badge ${statusClass}`}>
                              {item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase() : item.status}
                            </button>
                          </div>
                          
                          {item.complaint && (
                            <p className="disputes-reason-container">
                              <span className="disputes-reason-label">Reason</span> <span className="disputes-reason-value">{item.complaint}</span>
                            </p>
                          )}
                          
                          {item.raised_by_name && (
                            <p className="disputes-received-from-container">
                              <span className="disputes-received-from-label">Received From</span> <span className="disputes-received-from-value">{item.raised_by_name}</span>
                            </p>
                          )}
                          
                          {item.created_at && (
                            <p className="disputes-date-container">
                              Issue Received on {moment(item.created_at).format('MMM DD, YYYY ')}
                            </p>
                          )}
                          
                          {hasAttachment && (
                            <div 
                              className="disputes-attachment-container"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleFileClick(item.attach_file);
                              }}
                              onMouseDown={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <div onClick={(e) => e.stopPropagation()}>
                                <FilePreview fileUrl={item.attach_file} />
                              </div>
                            </div>
                          )}
                          
                          {hasAdminComment && (
                            <div className="disputes-admin-comment-container">
                              <p className="disputes-admin-comment-title">
                                Admin Comment:
                              </p>
                              <p className="disputes-admin-comment-text">
                                {item.admin_comments}
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })
                  )}
                </div>




               
              </div>
            )}
          </div>
        </div>

      </div>
      <Loader loading={loading} />
    </LoadingOverlay>

    <Modal
      isOpen={openIssue}
      onRequestClose={() => setOpenIssue(false)}
      style={customStyles}
      contentLabel="Example Modal"
      >
                  <LoadingOverlay>

        <div className="modal-dialog loginpopup disputes-modal-dialog" role="document">
        <div className="modal-content">
        <div className="loginpopup dashboard signin profile onbord-section disputes-modal-content">
          <div className="modal-header disputes-modal-header">
            <h5 className="modal-title disputes-modal-title"> Raise An Issue</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close"  onClick={()=>{
              setOpenIssue(false)
            }} >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body disputes-modal-body">
            <form action="#">
              <div className="inner post-a-new-job">


              <div className="form-group disputes-form-group">
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Title" 
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }} 
                  />
                   <small className="disputes-character-count">{title.length}/30 characters</small>

                </div>

              <div className="form-group disputes-form-group">
                <Select
                    className="form-control"
                    options={alljobId}
                    placeholder="Invoice No / Jobs"
                    onChange={(values) => {
                      if (values && values[0]) {
                        setJobId(values[0].label || values[0].value);
                      }
                    }}
                  />
                  {/* <select className="form-control">
                    <option selected="selected">Invoice No / Jobs</option>
                  </select> */}
                </div>

            


                <div className="form-group disputes-form-group">
                <Select
                    className="form-control"
                    options={[
                      {
                        label: 'Cancel Project / Service',
                        value: 'Cancel Project / Service',
                      },
                      {label: 'Not satisfactory', value: 'Not satisfactory'},
                      {label: 'Not Completed', value: 'Not Completed'},
                      {label: 'Not Available', value: 'Not Available'},
                      {
                        label: "Job provider didn't turn up",
                        value: "Job provider didn't turn up",
                      },
                      {
                        label: "Job poster didn't respond",
                        value: "Job poster didn't respond",
                      },
                      {label: 'Payment related', value: 'Payment related'},
                    ]}
                    placeholder="Issue"
                    onChange={(values) => {

                      setIssue(values[0].value);

                    }}
                  />
                </div>
               
                <div className="form-group disputes-form-group">
                  <textarea className="form-control disputes-textarea" placeholder="Provide more details about the Job." maxLength={350} rows="2" value={details}
                      onChange={(e) => {
                        setDetails(e.target.value);
                      }}
                onInput={(e) => {
                  e.target.style.height = '45px';
                  e.target.style.height = e.target.scrollHeight + 'px';
                }}      
                />
                <small className="disputes-character-count">{details.length}/350 characters</small>
                </div>
                <div className="form-group disputes-form-group">
                  <label className="filelabel">
                    <i className="fa fa-paperclip" aria-hidden="true" />
                    <span className="title">
                      Add File
                    </span>
                    <input type="file" 
                    className="files-dropzone disputes-file-input-hidden" 
                    onChange={handleFileSelect} 
                    onError={onFilesError}
                    accepts={["image/png", ".pdf"]}
                    multiple={false}
                    maxFileSize={1800000}
                    minFileSize={0}
                    />

                    {/* <Files
                    className="files-dropzone"
                    onChange={onFilesChange}
                    onError={onFilesError}
                    accepts={["image/png", ".pdf"]}
                    multiple={false}
                    maxFileSize={1800000}
                    minFileSize={0}
                    clickable
                  >
                 
                  </Files> */}
                  </label>
                  <label className="attche-ent-image-sec">{attachementFileName}</label>

                </div>
                <button  onClick={(e)=>{
                  e.preventDefault();
                  submitIssue()}} className="btn btn-default">SUBMIT</button>
              </div>
            </form>
          </div>
        </div>
      </div>
        </div>
        <Loader loading={issueloader} />
          </LoadingOverlay>
      </Modal>

      <Modal
        isOpen={filePreviewModal}
        onRequestClose={() => {
          setFilePreviewModal(false);
          setPreviewFileUrl('');
        }}
        style={filePreviewModalStyles}
        contentLabel="File Preview Modal"
      >
        <div className="disputes-file-preview-modal-container">
          <button
            onClick={() => {
              setFilePreviewModal(false);
              setPreviewFileUrl('');
            }}
            className="disputes-file-preview-close-button"
            aria-label="Close"
          >
            ×
          </button>
          <div className="disputes-file-preview-content">
            {previewFileUrl && (
              <div className="disputes-file-preview-inner">
                <FilePreview fileUrl={previewFileUrl} />
              </div>
            )}
          </div>
        </div>
      </Modal>
    
              </section>
  );
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
  },
  overlay: { zIndex: 1000 },
};

const filePreviewModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "98vw",
    height: "98vh",
    maxWidth: "98vw",
    maxHeight: "98vh",
    background: "transparent",
    border: "none",
    padding: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overlay: { 
    zIndex: 1001,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
export default connect(mapStateToProps, mapDispatchToProps)(DisputesView);
